import { Link } from 'react-router-dom'
import { ArrowRight, Clock, Tag } from 'lucide-react'
import SEO from '../components/SEO'
import { BLOG_POSTS } from '../data/blogPosts'

const BLOG_BREADCRUMB = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://myschoolportal.xyz' },
    { '@type': 'ListItem', position: 2, name: 'Blog', item: 'https://myschoolportal.xyz/blog' },
  ],
}

export default function Blog() {
  return (
    <div className="pb-16">
      <SEO
        title="Blog - School Insights for Ghana"
        description="Practical guides for Ghanaian school administrators on digitising fee collection, attendance, academic records and parent communication."
        path="/blog"
        schema={[BLOG_BREADCRUMB]}
      />

      {/* Hero */}
      <section className="px-4 pt-16 pb-14 text-center bg-grid-pattern">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-4xl sm:text-5xl font-display font-extrabold text-ink leading-[1.1] mb-5">
            School management<br />insights for Ghana
          </h1>
          <p className="text-lg text-[var(--ink-soft)] leading-relaxed">
            Practical guides for school administrators navigating digital transformation.
          </p>
        </div>
      </section>

      {/* Posts */}
      <section className="px-4 py-10 border-t border-theme">
        <div className="max-w-3xl mx-auto flex flex-col gap-px bg-[var(--rule-soft)] border border-theme rounded overflow-hidden">
          {BLOG_POSTS.map((post) => (
            <article key={post.slug} className="bg-surface p-6 md:p-8 grid md:grid-cols-[200px_1fr] gap-6 md:gap-8">
              {post.image && (
                <Link to={`/blog/${post.slug}`} className="block">
                  <img
                    src={post.image}
                    alt={post.imageAlt || ''}
                    className="w-full rounded border border-theme"
                    loading="lazy"
                    width={400}
                    height={260}
                    style={{ aspectRatio: '400 / 260', objectFit: 'cover' }}
                  />
                </Link>
              )}
              <div className="min-w-0">
              <div className="flex flex-wrap items-center gap-3 mb-4">
                <span className="flex items-center gap-1.5 text-xs font-semibold text-accent">
                  <Tag size={11} /> {post.category}
                </span>
                <span className="flex items-center gap-1.5 text-xs text-[var(--ink-soft)]">
                  <Clock size={11} /> {post.readingTime}
                </span>
                <time className="text-xs text-[var(--ink-soft)]">
                  {new Date(post.date).toLocaleDateString('en-GH', { year: 'numeric', month: 'long', day: 'numeric' })}
                </time>
              </div>

              <h2 className="text-xl md:text-2xl font-display font-bold text-ink mb-3">
                <Link to={`/blog/${post.slug}`}>{post.title}</Link>
              </h2>

              <p className="text-[var(--ink-soft)] leading-relaxed mb-5">
                {post.excerpt}
              </p>

              <Link
                to={`/blog/${post.slug}`}
                className="inline-flex items-center gap-2 text-sm font-semibold text-accent"
              >
                Read article <ArrowRight size={14} />
              </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  )
}
